
export const paddingCardsTables = 7;

export const timeToClosedToast = 12000;

export const mtDividerCardUSer = 2;

export const mtDividerUpTable = 2;

